interface CustomErrorMessageProps {
  type: 'error' | 'warn' | 'info';
  icon: React.ReactNode;
  headerText: string;
  description: React.ReactNode;
}

const TONES = {
  error: { tile: 'bg-state-err/[0.14] text-state-err' },
  warn: { tile: 'bg-state-warn/[0.14] text-state-warn' },
  info: { tile: 'bg-action/[0.14] text-action-soft' },
};

/**
 * The shell every blocking or advisory notice on the app pages renders into —
 * sleeping container, missing Dockerfile, unverified email, payment pending.
 *
 * Same shape as the status band above it: a tinted round tile, a Sora title,
 * and the explanation under it. The colour lives in the tile, not in the
 * heading — a 22px heading in alert yellow read as the loudest thing on a page
 * whose actual subject was somewhere below it.
 */
const CustomerErrorMessage = ({ type, icon, headerText, description }: CustomErrorMessageProps) => (
  <div className="rounded-card border border-navy-500 bg-navy-700 p-4 flex items-start gap-3.5">
    {/* `!text-current` so the icon takes the tile's tone: the callers each
        hardcode their own colour class on the SVG, and this is one override
        instead of ten edits. */}
    <span
      className={`w-[30px] h-[30px] flex-none rounded-full flex items-center justify-center [&_svg]:!text-current [&_svg]:w-4 [&_svg]:h-4 ${TONES[type].tile}`}
    >
      {icon}
    </span>
    {/* `self-start` on the buttons only: the column stretches its children, and
        an "Upgrade Now" that ran the full width of the card read as a banner
        rather than as the one action the notice offers. */}
    <div className="flex-1 min-w-0 flex flex-col gap-2 font-inter text-ds-135 leading-[1.55] text-navy-100 [&_button]:self-start [&_button]:mt-1">
      <span className="font-sora text-ds-15 font-semibold tracking-[-0.01em] text-white">
        {headerText}
      </span>
      {description}
    </div>
  </div>
);

export default CustomerErrorMessage;
